import React from 'react';
import { WithStyles } from '@material-ui/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import ProfileForm from '../../components/ProfileForm';
import styles from './styles';
import { UserData } from '../../redux/selectors/auth';

type Props = {
  user: UserData;
  loadAgentById: (username: string) => void;
  updateAgentById: (payload: Record<string, any>, id: string | number) => void;
} & WithStyles<typeof styles>;

const EditProfile: React.FC<Props> = (props) => {
  const {
    classes, user, updateAgentById,
  } = props;

  function handleSave(agentPayload: Record<string, any>): void {
    updateAgentById(agentPayload, user.username);
  }

  if (!user) {
    return (
      <div className={classes.progressWrapper}>
        <CircularProgress size={48} className={classes.progress} />
      </div>
    );
  }

  return (
    <ProfileForm user={user} onSave={handleSave} />
  );
};

export default React.memo(EditProfile);
